window.onload = function () {
  try {
    localStorage.setItem("check-navigation", "assinauai");
  } catch (e) {
    window.location.href = "/browsers.html"
  }
}